import createUseStyles from '@eduzz/houston-styles/createUseStyles';

export const useStyles = createUseStyles((theme) => ({
  dialogTitle: {
    padding: theme.spacing.fn(4),
  },
  dialogTitleText: {
    display: 'flex',
    alignItems: 'center',
  },
  dialogContent: {
    padding: theme.spacing.fn(4),
  },
  dialogActions: {
    padding: theme.spacing.fn(4),
  },
  alertIcon: {
    marginRight: theme.spacing.fn(2),
    color: theme.feedbackColor.informative.pure,
  },
}));
